import type { HTMLAttributes, ReactNode } from "react";

export interface StatusMessageProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  tone?: "info" | "warning" | "danger";
  live?: "off" | "polite" | "assertive";
}

export function StatusMessage({
  children,
  className,
  tone = "info",
  live = "polite",
  ...props
}: StatusMessageProps) {
  return (
    <div
      {...props}
      aria-live={live}
      className={["ui-status", className].filter(Boolean).join(" ")}
      data-tone={tone}
      role={tone === "danger" ? "alert" : "status"}
    >
      {children}
    </div>
  );
}
